import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]

import BaseFilterComponent from './BaseFilterComponent.vue'

interface Option {
  value: any
  label: string
}

interface Props {
  label: string
  modelValue: any
  options: Option[] | any[]
  valueKey?: string
  labelKey?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectFilterComponent',
  props: {
    label: {},
    modelValue: {},
    options: {},
    valueKey: { default: 'value' },
    labelKey: { default: 'label' }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const getOptionValue = (option: any) => {
  if (typeof option === 'object') {
    return option[props.valueKey]
  }
  return option
}

const getOptionLabel = (option: any) => {
  if (typeof option === 'object') {
    return option[props.labelKey]
  }
  return option
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseFilterComponent, { label: __props.label }, {
    default: _withCtx(() => [
      _createElementVNode("select", {
        value: __props.modelValue,
        class: "form-select",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLSelectElement).value))),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', ($event.target as HTMLSelectElement).value)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: getOptionValue(option),
            value: getOptionValue(option)
          }, _toDisplayString(getOptionLabel(option)), 9, _hoisted_2))
        }), 128))
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})